var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.70504L3.9396 12.5683C4.03829 12.705 4.16516 12.813 4.32025 12.8777C4.46829 12.9568 4.61634 12.9856 4.77847 13C4.94061 13 5.10272 12.964 5.24371 12.8993C5.39175 12.8345 5.5116 12.7338 5.61734 12.6043L15 1",
    stroke: "#666666",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSave);
export default __webpack_public_path__ + "static/media/edit-save.d0ff42ada5f4ea0d7a29f0ae4d026923.svg";
export { ForwardRef as ReactComponent };